import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "../../common/CustomModal.css";
import api from "../../../seller-apis/api";

const SellerRemarkModal = ({ show, handleClose, handleConfirm, leadId }) => {
  const [comment, setComment] = useState(false);
  const saveComment = () => {
    let param = {
      _id: leadId,
      comment: [
        {
          desc: comment,
          createdAt: new Date(),
        },
      ],
    };
    api.customerLeads.addLeadComment(param).then((res) => {
      handleClose();
    });
  };

  return (
    <Modal
      className="custom-modal1 p-10"
      size="md"
      centered
      show={show}
      onHide={handleClose}
    >
      <div class="header-pop p-3 mb-1">
        <div class="header-title">Add your remark</div>
        <a class="close-pop" onClick={() => handleClose()}>
          ×
        </a>
      </div>
      <Modal.Body style={{ width: "100%" }}>
        {/* <p className="light-title text-left">Add your remark</p> */}
        <div className="answer my-1">
          <textarea
            className="form-control"
            onChange={(e) => setComment(e.target.value)}
          ></textarea>
        </div>
        <div className="text-center my-3">
          <button
            className="apply-btn px-3 fs-12"
            onClick={() => saveComment()}
            disabled={!comment}
          >
            Submit
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SellerRemarkModal;
